//Take in an array of elements and set them all to height of the tallest El
export function setAllToMaxHeight(elements) {
    console.log('setAllToMaxHeight called');
    if(typeof elements == 'object' ){
        let maxHeight = 0;
        elements.forEach(el => {
            el.style.height = '';
        });
        elements.forEach(el => {
            if (el.offsetHeight > maxHeight) {
                maxHeight = el.offsetHeight;
            }
        });
    
        elements.forEach(el => {
            el.style.height = maxHeight + 'px';
        });
    } else {
        console.error("Invalid argument for elements:",typeof elements, elements);
    }
}